export default function Footer() {
  return (
    <footer id="footer" className="bg-foreground-950 text-background-100">
      <div className="w-full px-4 md:px-6 max-w-7xl mx-auto py-12 md:py-16">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8 md:gap-10">
          {/* Brand */}
          <div className="sm:col-span-2 lg:col-span-1">
            <a href="#hero" className="inline-flex items-center gap-2 mb-4 cursor-pointer">
              <div className="w-9 h-9 rounded-lg bg-primary-500 flex items-center justify-center">
                <i className="ri-movie-2-line text-background-50 text-lg" style={{ width: '1em', height: '1em' }}></i>
              </div>
              <span className="text-lg font-heading font-bold text-background-50 tracking-tight">
                6080<span className="text-primary-400">影视</span>
              </span>
            </a>
            <p className="text-sm text-foreground-400 leading-relaxed mb-4">
              6080影视是专业的动漫番剧免费高清在线观看平台，提供不缓冲流畅追番体验。
              海量免费动漫大全覆盖日漫、国漫、经典番剧，每周更新，高清画质流畅播放。
            </p>
            <div className="flex items-center gap-3">
              <a href="#hero" className="w-9 h-9 rounded-lg bg-foreground-800 flex items-center justify-center hover:bg-primary-500 transition-colors cursor-pointer">
                <i className="ri-weibo-line text-background-100 text-sm" style={{ width: '1em', height: '1em' }}></i>
              </a>
              <a href="#hero" className="w-9 h-9 rounded-lg bg-foreground-800 flex items-center justify-center hover:bg-primary-500 transition-colors cursor-pointer">
                <i className="ri-bilibili-line text-background-100 text-sm" style={{ width: '1em', height: '1em' }}></i>
              </a>
              <a href="#hero" className="w-9 h-9 rounded-lg bg-foreground-800 flex items-center justify-center hover:bg-primary-500 transition-colors cursor-pointer">
                <i className="ri-wechat-line text-background-100 text-sm" style={{ width: '1em', height: '1em' }}></i>
              </a>
            </div>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="text-sm font-semibold text-background-50 mb-4">快速导航</h4>
            <div className="flex flex-col gap-2">
              <a href="#ranking" className="text-sm text-foreground-400 hover:text-primary-400 transition-colors cursor-pointer">追番排行</a>
              <a href="#cards" className="text-sm text-foreground-400 hover:text-primary-400 transition-colors cursor-pointer">热门番剧</a>
              <a href="#media" className="text-sm text-foreground-400 hover:text-primary-400 transition-colors cursor-pointer">精选推荐</a>
              <a href="#updates" className="text-sm text-foreground-400 hover:text-primary-400 transition-colors cursor-pointer">更新动态</a>
            </div>
          </div>

          {/* Categories */}
          <div>
            <h4 className="text-sm font-semibold text-background-50 mb-4">动漫分类</h4>
            <div className="flex flex-col gap-2">
              <a href="#index" className="text-sm text-foreground-400 hover:text-primary-400 transition-colors cursor-pointer">日漫番剧</a>
              <a href="#index" className="text-sm text-foreground-400 hover:text-primary-400 transition-colors cursor-pointer">国漫精品</a>
              <a href="#index" className="text-sm text-foreground-400 hover:text-primary-400 transition-colors cursor-pointer">经典番剧</a>
              <a href="#index" className="text-sm text-foreground-400 hover:text-primary-400 transition-colors cursor-pointer">动漫大全</a>
            </div>
          </div>

          {/* Partners */}
          <div>
            <h4 className="text-sm font-semibold text-background-50 mb-4">合作伙伴</h4>
            <p className="text-sm text-foreground-500 leading-relaxed">
              合作伙伴信息即将更新，敬请期待。
            </p>
          </div>
        </div>

        {/* Bottom bar */}
        <div className="mt-10 md:mt-12 pt-6 border-t border-foreground-800/60 flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="text-xs text-foreground-500">
            © 2024 6080影视 - 动漫番剧免费高清在线观看平台。本站所有资源均来自互联网，仅供交流学习使用。
          </p>
          <div className="flex items-center gap-4">
            <a href="#hero" className="text-xs text-foreground-500 hover:text-primary-400 transition-colors cursor-pointer">关于我们</a>
            <a href="#faq" className="text-xs text-foreground-500 hover:text-primary-400 transition-colors cursor-pointer">常见问题</a>
            <a href="#contact" className="text-xs text-foreground-500 hover:text-primary-400 transition-colors cursor-pointer">联系我们</a>
          </div>
        </div>
      </div>
    </footer>
  );
}